import { differenceInCalendarDays } from "date-fns";

export const isDayWithinBounds = (
	day: Date,
	minDate?: Date,
	maxDate?: Date,
): boolean => {
	const afterMinimum =
		minDate === undefined || differenceInCalendarDays(day, minDate) >= 0;
	const beforeMaximum =
		maxDate === undefined || differenceInCalendarDays(day, maxDate) <= 0;

	return afterMinimum && beforeMaximum;
};
